import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function ChevronIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10.8532 5.12413C10.5527 4.66075 9.93347 4.52869 9.47008 4.82918C9.0067 5.12966 8.87464 5.74891 9.17513 6.21229L10.8532 5.12413ZM14.0142 11.8367L14.8633 12.3649L15.1988 11.8256L14.8532 11.2926L14.0142 11.8367ZM9.16505 17.7384C8.87332 18.2073 9.01699 18.824 9.48594 19.1157C9.95488 19.4074 10.5715 19.2638 10.8633 18.7948L9.16505 17.7384ZM9.17513 6.21229L13.1751 12.3808L14.8532 11.2926L10.8532 5.12413L9.17513 6.21229ZM13.1651 11.3085L9.16505 17.7384L10.8633 18.7948L14.8633 12.3649L13.1651 11.3085Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root} style={{ transform: props.transform }}>
			<ChevronIcon fill={props.fill} />
		</div>
	);
}